import React, { useContext, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import DayInput from "react-day-picker/DayPickerInput";
import { Loading } from "../../components/Loading";

import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import { DefaultButton, MyModalBody, MyModalInput } from "../../style/default";
import { RichtextEditor } from "./text-editor";

const EditUpdateModal = ({ open, data, handleUpdates }) => {
	const { handleOpenModal } = useContext(ModalContext);

	const [isLoading, setIsLoading] = useState(false);
	const [selectedDay, setSelectedDay] = useState(new Date());
	const [content, setContent] = useState(data?.content);

	const title = useRef(null);

	const handleDayChange = (day) => {
		setSelectedDay(day);
	};

	const handleUpdateEdit = async () => {
		try {
			setIsLoading(true);
			const request = {
				title: title.current.value,
				content,
				updateDate: selectedDay,
			};
			await authApi.post(`/updates/${data._id}`, request);
			setIsLoading(false);
			handleUpdates();
			handleOpenModal();
		} catch (error) {
			setIsLoading(false);
			handleOpenModal();
		}
	};

	return (
		<Modal show={open} onHide={handleOpenModal} size="lg" backdrop="static">
			{isLoading ? <Loading /> : null}
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Edição da atualização: {data?.title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<label>Título da atualização</label>
					<MyModalInput
						ref={title}
						defaultValue={data?.title}
						type="text"
						placeholder="ex: Sem mais problemas para gerar relatórios"
					/>
					<label>Conteúdo da atualização</label>
					<RichtextEditor content={content} setContent={setContent} />
					<label>Data da atualização</label>
					<DayInput
						placeholder="Ex: 27/07/2021"
						onDayChange={handleDayChange}
						value={data?.updateDate}
					/>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton onClick={handleUpdateEdit}>Editar</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
};

export { EditUpdateModal };
